<template>
  <v-dialog
    persistent
    overlay-opacity="0.46"
    overlay-color="#000"
    attach="#global-action-dialogue"
    content-class="dialog-component-container s-dialog global-action-dialogue-wrapper"
    v-model="openState">
    <div>
      <div class="dialog__title-container">
        <div class="dialog__title-content">
          <h1 class="dialog__title">{{ actionTitle }}</h1>
          <h3 class="dialog__subtitle" v-html="actionDescription"></h3>
        </div>
        <v-btn
          icon="close"
          variant="text"
          class="dialog__close-btn"
          @click="closeX">
        </v-btn>
      </div>
      <div class="dialog--global-action-prompt">
        <div class="global-action-prompt--container">
          <div class="row-buttons">
            <v-btn color='primary' @click="clickYes">{{ labelYesDisplay }}</v-btn>
            <v-btn color='cancel' @click="clickNo">{{ labelNoDisplay }}</v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'global-action-prompt',
  computed: {
    ...mapState({
      openState: state => state.globalActionPrompt.show,
      actionTitle: state => state.globalActionPrompt.actionObj.title,
      actionDescription: state => state.globalActionPrompt.actionObj.description,
      labelYes: state => state.globalActionPrompt.actionObj.labelYes,
      labelNo: state => state.globalActionPrompt.actionObj.labelNo
    }),
    labelYesDisplay() {
      return this.labelYes || this.$t('labels:YES_NO.YES')
    },
    labelNoDisplay() {
      return this.labelNo || this.$t('labels:YES_NO.NO')
    }
  },
  methods: {
    ...mapActions({
      clickYes: 'VUEX_GLOBAL_ACTION_PROMPT_YES',
      clickNo: 'VUEX_GLOBAL_ACTION_PROMPT_NO',
      closeX: 'VUEX_GLOBAL_ACTION_PROMPT_CLOSEX'
    }),
    handleKeyDown(event) {
      if (!this.openState) return
      if (event.key === 'Enter') {
        this.clickYes()
      } else if (event.key === 'Escape') {
        this.closeX()
      }
    }
  },
  watch: {
    openState: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          window.addEventListener('keydown', this.handleKeyDown)
        } else {
          window.removeEventListener('keydown', this.handleKeyDown)
        }
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown)
  }
}
</script>

<style lang="scss">
#global-action-dialogue {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}

.global-action-dialogue-wrapper {
  &.v-overlay__content {
    &.dialog-container {
      background-color: transparent !important;
    }
  }

  .dialog--global-action-prompt {
    display: flex;
    flex-direction: column;
    min-width: 400px;
    // width: 27rem !important;
    min-height: 5rem;
    max-height: 20rem;
    overflow: auto;

    .global-action-prompt--container {
      width: 100%;
      position: relative;
      padding: 30px;
      background-color: #fff;

      .row-fields,
      .row-buttons {
        width: 80%;
        margin: 0 auto;
      }

      .row-fields {
        h3 {
          span {
            font-size: small;
            opacity: 0.3;
          }
        }
      }

      .row-buttons {
        margin: 20px 0;
        display: flex;
        justify-content: center;
        width: 100%;

        .v-btn {
          margin: 0 10px;
        }
      }
    }
  }
}
</style>
